import { TypedEmitter, ListenerSignature } from 'tiny-typed-emitter';

export abstract class BaseTypedEmitter<K extends ListenerSignature<K> = ListenerSignature<unknown>>
  extends TypedEmitter<K>
  implements Realtime.Core.IBaseTypedEmitter<K>
{
  constructor() {
    super();
    this.setMaxListeners(20);
  }

  destroy() {
    this.removeAllEventEmitterListeners();
  }

  countAllListeners() {
    const eventNames: (keyof K)[] = this.eventNames();
    if (eventNames?.length) {
      for (let i = 0; i < eventNames.length; i++) {
        const event = eventNames[i];
        logger.info(`Event: ${event.toString()} count: ${this.listenerCount(event)}`);
      }
    }
  }

  protected removeAllEventEmitterListeners() {
    const eventNames: (keyof K)[] = this.eventNames();
    if (eventNames?.length) {
      for (let i = 0; i < eventNames.length; i++) {
        const event = eventNames[i];
        this.removeAllListeners(event);
      }
    }
  }
}
